import type { CabinetCaseDetail } from '../../api/types';
import { useI18n, useT } from '../../i18n';
import { formatDate } from '../../lib/format';
import { loc } from '../../lib/loc';
import { isStepKey, stepLabelKey } from './stepModel';
import { describeEvent } from './model';

export function TimelineSection({ detail }: { detail: CabinetCaseDetail }) {
  const t = useT();
  const locale = useI18n((s) => s.locale);
  const states = new Map(detail.states.map((s) => [s.key, loc(s.name, locale)]));
  const docs = new Map(detail.checklist.map((i) => [i.document_type?.key, loc(i.document_type?.name, locale)]));
  const events = detail.events
    .filter((e) => e.client_visible !== false)
    .slice()
    .sort((a, b) => Date.parse(b.occurred_at) - Date.parse(a.occurred_at));

  return (
    <section aria-labelledby="tl-h" id="history" className="scroll-mt-6">
      <h2 id="tl-h" className="sec-h">
        {t('timeline.title')}
      </h2>
      {events.length === 0 ? <p className="mt-5 text-[16px] text-txt">{t('timeline.empty')}</p> : null}
      <ol className="mt-2">
        {events.map((e) => {
          const d = describeEvent(e, {
            locale,
            stateName: (k) => states.get(k),
            docName: (k) => docs.get(k),
            stepName: (k) => (isStepKey(k) ? t(stepLabelKey(k)) : undefined),
          });
          return (
            <li key={e.id} className="row flex flex-col gap-1 py-4 sm:flex-row sm:items-baseline sm:gap-6">
              <time dateTime={e.occurred_at} className="flex-none text-[13px] text-lab sm:w-40">
                {formatDate(e.occurred_at, locale)}
              </time>
              <span className="text-[16px]">{t(d.key, d.vars)}</span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
